import { useQuery } from '@tanstack/react-query'
import { PlayLogService } from '../../services/playlog.service'
import type { GetPlayLogsParams } from '@/modules/dashboard/type'
import { DashboardKeys } from '@/modules/dashboard/keys'

export default function useQueryGetPlayLogs(params?: GetPlayLogsParams) {
	return useQuery({
		queryKey: [DashboardKeys.PlayLogs, params],
		queryFn: () => PlayLogService.getPlayLogs(params),
	})
}
